import React, { CSSProperties } from 'react';

const DEFAULT_STYLE: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
};

function ChartWrapper({ children }: { children: React.ReactNode }) {
  return <div style={DEFAULT_STYLE}>{children}</div>;
}

export default ChartWrapper;
